<template>
  <div id="app">
    <b-navbar class="base_navbar" type="light"  toggleable="md">

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand :to="{ path: '/' }">
        <img class='brand_logo' :src="require('@/assets/images/audas_pro_logo.jpg')" alt="Logo audas Pro">
      </b-navbar-brand>

      <b-collapse is-nav id="nav_collapse" >
        <b-navbar-nav class="ml-auto">
          <b-nav-item  class="navbar_items" to="/" > Accueil </b-nav-item>
          <b-nav-item-dropdown class="navbar_items" text="Mesures spéciales COVID">
            <b-dropdown-item @click="goToEmployeursCovid">Employeurs</b-dropdown-item>
            <b-dropdown-item @click="goToSalariesCovid('PERM')">Salariés permanents</b-dropdown-item>
            <b-dropdown-item @click="goToSalariesCovid('INTER')">Salariés intermittents</b-dropdown-item>
            <b-dropdown-item @click="goToSalariesCovid('PIG')">Salariés journalistes pigistes</b-dropdown-item>
            <b-dropdown-item @click="goToBranchesProCovid">Branches professionnelles</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown class="navbar_items" text="Autres services partagés">
            <b-dropdown-item @click="goToOtherEmployeurs">Employeurs</b-dropdown-item>
            <b-dropdown-item @click="goToOtherSalaries('PERM')">Salariés permanents</b-dropdown-item>
            <b-dropdown-item @click="goToOtherSalaries('INTER')">Salariés intermittents</b-dropdown-item>
            <b-dropdown-item @click="goToOtherSalaries('PIG')">Salariés journalistes pigistes</b-dropdown-item>
            <!--<b-dropdown-item @click="goToBranchesPro">Branches professionnelles</b-dropdown-item>-->
          </b-nav-item-dropdown>


          <b-nav-item  class="navbar_items" to="/qui-sommes-nous" > Qui sommes-nous ?</b-nav-item>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>
    <div class="content">
      <router-view/>
    </div>
    <div class="mt-4">
      <footerComponent />
    </div>
  </div>
</template>

<script>
import { setOptions, bootstrap } from 'vue-gtag'
import footerComponent from '@/components/footerComponent'

window.axeptioSettings = {
  clientId: "605b4a9125fdd05e1b21c0f8",
  cookiesVersion: "audaspro-base",
};

(function(d, s) {
  var t = d.getElementsByTagName(s)[0], e = d.createElement(s);
  e.async = true; e.src = "//static.axept.io/sdk.js";
  t.parentNode.insertBefore(e, t);
})(document, "script");


void 0 === window._axcb && (window._axcb = []);
window._axcb.push(function(axeptio) {
  axeptio.on("cookies:complete", function(choices) {
    if (choices['google_analytics'] == true) {
      setOptions({
        config: { id: 'G-P3SM3R6PCG' }
      })
      bootstrap().then(() => {
        // all done!
      })
    }
    else {
      setOptions({
        enabled: false
      })
    }
  })
})



export default {
  name: 'App',
  components: {
    footerComponent,
  },
  computed: {
    typeSalarie: {
      get () {
        return this.$store.state.characteristics.typeSalarie
      },
      set (value) {
        this.$store.commit('characteristics/set', ['typeSalarie', value])
      }
    },
  },
  methods: {
    goToEmployeursCovid () {
       this.$router.push('/covid/employeurs')
    },
    goToSalariesCovid (type) {
      this.typeSalarie = type
      this.$router.push('/covid/salaries')
    },

    goToOtherEmployeurs () {
       this.$router.push('/autre/employeurs')
    },
    goToOtherSalaries (type) {
      this.typeSalarie = type
      this.$router.push('/autre/salaries')
    },

    goToBranchesProCovid () {
       this.$router.push('/covid/branches-professionnelles')
    },

  }
}
</script>

<style lang="scss">

// Import custom SASS variable overrides, or alternatively
// define your variable overrides here instead
@import 'assets/styles/custom-vars.scss';

// Import Bootstrap and BootstrapVue source SCSS files
@import '~bootstrap/scss/bootstrap.scss';
@import '~bootstrap-vue/src/index.scss';

/* ROBOTO */
@font-face{
  font-family: "Roboto";
  src: url("./assets/fonts/roboto/Roboto-Bold.ttf");
  font-style : normal;
  font-weight : 800;
  text-rendering : optimizeLegibility;
  font-display: swap;
}

@font-face{
  font-family: "Roboto";
  src: url("./assets/fonts/roboto/Roboto-Medium.ttf");
  font-style : normal;
  font-weight : 500;
  text-rendering : optimizeLegibility;
  font-display: swap;
}

@font-face{
  font-family: "Roboto";
  src: url("./assets/fonts/roboto/Roboto-Regular.ttf");
  font-style : normal;
  font-weight : 400;
  text-rendering : optimizeLegibility;
  font-display: swap;
}


html, body {
  font-family: Roboto, sans-serif !important;
  padding-right: 0 !important;
}


.masthead {
  padding-top: 2%;
  padding-bottom: 2%;
}

.justify-text {
  text-align: justify;
}


#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  height: 100%;
  /* color: #2c3e50; */

}

.content {
  flex: 1 0 auto;
  /* Prevent Chrome, Opera, and Safari from letting these items shrink to smaller than their content's default minimum size. */
  padding: 2px;
}


.base_navbar {
  height: 60px;
}

#nav_collapse {
  background-color: white;
  z-index: 1001;
}

.navbar-nav>li{
  border-right: 0.5px solid rgba(0, 0, 0, 0.5);
}


.brand_logo {
  height: 30px;
}


.navbar_items {
  font-weight: bold;
  font-size: 14px;
}


#form-section-banner {
  background-size: cover;
  background-position:center;
  height: 150px;
  line-height: 100px;
  /* Add the blur effect */
}

.form-section-banner-title {
  color: white;
  text-transform: uppercase;
  font-size: 28px;
  display: inline-block;
  vertical-align: middle;
}

.form_div {
  background: #FFFFFF;
  padding-left: 15px;
  padding-bottom: 20px;
  border-style: solid;
  border-color: #BDBDBD;
  border-width: 0.5px;
  margin-top: 15px;
  margin-top: -50px;
}

.form_div_title {
  color: #d6075b;
}



.form_content {
  margin-top: 10px;
  padding-left: 15px;
  padding-right: 15px;
}

.form_content h2 {
  color: #d6075b;
  margin-top:10px;
  font-size: calc(1.2em + 0.4vw);
}

.form_content h3 {
  margin-top:20px;
  font-size: calc(1.1em + 0.3vw);
}



@media (min-width: 576px) {
  .brand_logo {
    height: 35px;
  }
  .navbar_items {
    font-size: 14px;
    padding-left: 5px;
    padding-right: 5px;
  }

  #form-section-banner {
    height: 200px;
    line-height: 150px;
  }
  .form-section-banner-title {
    font-size: 34px;
  }
}



@media (min-width: 992px) {
  .base_navbar {
    height: 100px !important;
  }

  .brand_logo {
    height: 60px;
  }
  .navbar_items {
    font-size: 16px;
    padding-left: 5px;
    padding-right: 5px;
  }

  #form-section-banner {
    height: 250px;
    line-height: 200px;
  }
  .form-section-banner-title {
    font-size: 40px;
  }

}

@media (min-width: 1300px) {
  .brand_logo {
    height: 75px;
  }
  .navbar_items {
    font-size: 18px;
    padding-left: 20px;
    padding-right: 20px;
  }
}

</style>
